/**
 * Shared marker between `FocusToggle` and `Splitter`: the splitter must never
 * treat a press or double-click on the toggle it hosts as the start of a drag
 * or a reset (see `Splitter`'s `isFocusToggleEvent`).
 */
export const FOCUS_TOGGLE_ATTRIBUTE = 'data-focus-toggle';
export const FOCUS_TOGGLE_SELECTOR = `[${FOCUS_TOGGLE_ATTRIBUTE}]`;
